import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className:
    'flex flex-col gap-2xl rounded-md bg-background-default p-2xl sm:grid sm:grid-cols-2 md:gap-x-[72px]'
});

export const CopySection = createComponent('div', {
  className:
    'flex flex-col gap-xl sm:col-span-2 md:col-span-1 md:col-start-1 md:row-start-1 md:self-end'
});

export const Title = createComponent('p', {
  className: 'text-text-strong t-heading-xl md:t-heading-2xl'
});

export const SubTitle = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const ImageLink = createComponent('a', {
  className:
    'self-center sm:col-start-2 sm:row-start-2 sm:self-auto md:row-span-2 md:row-start-1 md:self-center lg:self-stretch'
});

export const ImageContainer = createComponent('div', {
  className: 'aspect-[2/1] w-full overflow-hidden rounded-md bg-background-weak'
});

export const VehicleData = createComponent('div', {
  className:
    'flex flex-col gap-2xl sm:col-start-1 sm:row-start-2 sm:self-center md:gap-xl md:self-start'
});

export const VehicleImage = createComponent('img', {
  className: 'h-full w-full object-cover object-center'
});

export const YMMTWrapper = createComponent('div', {
  className: 'flex min-w-0 flex-1 flex-col justify-center gap-sm'
});

export const VehicleName = createComponent('p', {
  className: 'truncate text-text-strong t-heading-sm sm:t-heading-md'
});

export const TrimMileage = createComponent('div', {
  className: 'flex flex-col text-text-weak t-body-sm sm:flex-row sm:gap-sm'
});
